module.exports = __webpack_public_path__ + "static/media/FileSettings.b30f7e43.svg";